<script>
	export let lang, dataset, container
	import Portal from 'svelte-portal'
	import CartControl from './CartControl.svelte'
	import Shipping from './Shipping.svelte'
	import Price from './Price.svelte'
	import ProductFlags from "./ProductFlags.svelte";
	import en from "../strings.en"
	import fr from "../strings.fr"
	import { quantity, postal, shipping, method } from './store.js'
	import {openProductLocator} from "./utilities"
	import SqFtCalculator from './SqFtCalculator.svelte';

	let coveragePrice = dataset.pricePerSqFt || false
	let productCode = dataset.productCode || false
	let productName = dataset.productName || false
	let productBrand = dataset.productBrand || false
	let preferredStore = false
	let preferredStoreAttr = false
	let availability = false
	let onlineMessage = false
	let preferredStoreAddress = false
	let dotw = dataset?.productDotw || false
	let onlineOnlyProduct = (dataset?.productOnlineOnly?.toString() == 'true' ? true : false) || false
	let cartControlProps = {}
	let loyaltyEligible = dataset.loyaltyEligible || false
	let isProBrand = (dataset?.productProBrand?.toString() == 'true' ? true : false) || false
	//loyalty incognito flags
	let useLoyaltyService = dataset.useLoyaltyService || "false"
	let displayLoyaltyToEndUser = dataset.displayLoyaltyToEndUser || "false"
	let dynAttr21 = dataset.tenantDynattribute21 || "false"
	let dynAttr295 = dataset.tenantDynattribute295 || false

	// made in canada props
	let isMadeInCanada = dataset?.isMadeInCanada || false
	let isProductOfCanada = dataset?.isProductOfCanada || false

	let lastFetchedLocations = false
	let thinking = false

	let errorCode;
	let strings = en;
	if(lang =='fr'){
		strings = fr;
	}
	let _strings = strings.strings
	//const en = lang != "fr"

	let infoModal = false
	let coupons = [];
	const categories = [];

    let buyabilityDataLayer = false

	function formatMoney(amount) {
		return new Intl.NumberFormat(`${lang}-CA`, { style: 'currency', currency: 'CAD' }).format(amount)
	}

	async function fetchBuyability(productCode, preferredStore, preferredWarehouse) {
		const response = await fetch(`/_data/${lang}/buyability/${productCode}-${preferredStore}-${preferredWarehouse}?defaultProductFetch=true`, {
			method: 'get',
			headers: {"Content-Type": "application/json"}
		})
		const data = await response.json()
		return data
	}

	async function fetchCoupon() {
		getCategories(JSON.parse(dataset.productCategories))
		const payload = {
			'productData': [{
				'productCode': productCode,
				'categoryId': [...new Set(categories)] // To get unique category id's
			}],
			'discountType': 'LineItem',
			'storeCode': preferredStore.toString()
		}
		const response =  await fetch(`/_data/${lang}/discounts`, {
			method: 'post',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload)
		});

		coupons = await response.json()


	}

	function getCategories(categories){
		categories.forEach(function (category){
			getCategory(category);
		})
	}

	function getCategory(category){
		if(category){
			getCategory(category?.parentCategory);
			categories.push(category?.categoryId);
		}
	}

	function scrollToSimilarItems() {
		document.querySelector('hh-product-recs')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
	}

	function main() {
		try {
			
			preferredStore = localStorage.preferredStore ? parseInt( JSON.parse(localStorage.preferredStore)?.code || localStorage.preferredStore ) : false
			if (!preferredStore) throw "no preferred store"

			preferredStoreAttr = localStorage.preferredStoreAttr ? JSON.parse(localStorage.preferredStoreAttr) || false : false
			if (!preferredStoreAttr) throw "no preferred store attributes"

			let preferredWarehouse = parseInt(preferredStoreAttr.tenantWarehouse || preferredStoreAttr.find(a => a.fullyQualifiedName == "tenant~warehouse")?.values?.shift() || 0)
			if (!preferredWarehouse) throw "no preferred warehouse"

			preferredStoreAddress = JSON.parse(localStorage.preferredStore);

			const fetchingLocations = `${productCode},${preferredStore},${preferredWarehouse}`

			if (lastFetchedLocations == fetchingLocations) return false
			
			thinking = true

			fetchBuyability(productCode, preferredStore, preferredWarehouse)
			.then(data => {
                /** ENDOR-570 NOT_IN_PRICELIST datalayer push */
				if(data?.codes.includes('NOT_IN_PRICELIST')){
                    buyabilityDataLayer = {
                        event: "buyability",
                        data: {
                            Purchasable: {
                                inPriceList: "No"
                            }
                        }
                    }
                    window.dataLayer.push(buyabilityDataLayer)
                    buyabilityDataLayer = false
                    throw 'NOT_IN_PRICELIST'
                } 
				if (!data || !data.inventory) throw "bad API response"
				availability = data
                
                window.dispatchEvent(new CustomEvent('gtmdetailview', {
                    detail: {
                        productPrice: availability.price.salePrice ? availability?.price?.salePrice : availability?.price?.price || ''
                    }
                } ))

				cartControlProps = {
					buyability: availability.buyable,
					buyabilityFlags: availability.debug,
					lang,
					productCode,
					ehf: availability.ehf,
					maxQty: availability.maxQty,
					llQty: availability.llQty,
					productName: dataset.productName,
					productBrand: dataset.productBrand,
					productCategory: dataset.productCategory,
					productCategoryCrumbs: dataset.productCategorycrumbs,
					price: availability.price,
					loyaltyEligible: loyaltyEligible,
					useLoyaltyService: useLoyaltyService,
					displayLoyaltyToEndUser: displayLoyaltyToEndUser,
					isProBrand: isProBrand,
					isMadeInCanada : isMadeInCanada,
					isProductOfCanada : isProductOfCanada,
					availability : availability
				}
                /**
                 * ENDOR-501 datalayer buyability event
                */
                buyabilityDataLayer = {
                    event: "buyability",
                    data: {
                        storeType: availability?.debug?.storeNRTI ? "NRTI" : "Non-NRTI",
                        bopisTimeline: undefined,
                        rating: dataset?.productRating || undefined,
                        Purchasable: {
                            online: availability?.debug?.isEcommerceItem ? 'Yes' : 'No',
                            store: availability?.debug?.storeEcom ? 'eCom' : 'Non-eCom',
                            BOPIS: availability?.codes?.includes('BOPIS_ONLY') || availability?.codes?.includes('IN_STOCK_ONLINE') ? 'Yes' : 'No',
                            S2H: availability?.codes?.includes('SHIP_TO_HOME_ONLY') || availability?.codes?.includes('IN_STOCK_ONLINE') ? 'Yes': 'No',
                            supplierDirect: availability?.debug?.isSupplierDirectItem ? 'Yes' : 'No',
                            inPriceList: availability?.codes?.includes('FULL_ASSORTMENT') ? 'No' : 'Yes'
                        },
                        Inventory: {
                            store: availability?.inventory?.store,
                            primaryDC: availability?.inventory?.warehouse,
                            S2H: availability?.inventory?.sth
                        }

                    }
                }
                if(!(availability?.codes?.includes('BOPIS_ONLY') || availability?.codes?.includes('IN_STOCK_ONLINE'))) {
                    window.dataLayer.push(buyabilityDataLayer)
                    buyabilityDataLayer = false
                }

				lastFetchedLocations = fetchingLocations
				thinking = false
				if(availability.buyable) fetchCoupon()
				return availability
			})
			.catch(error => {
				errorCode=error
				thinking = false
			})
			// onlineOnlymsg();

		} catch (error) {
			console.warn("PDP BUY ERROR", error)
			availability = false
			thinking = false
			return
		}
	}
	function onlineOnlymsg(){
		const onlineOnlyProductcode= availability.debug?.themeProducts?.split(",")
		const startDate = new Date(availability.debug?.startDate)
		const endtDate = new Date(availability.debug?.endtDate) 
		var currentdate = new Date()

		onlineOnlyProductcode?.forEach(element => {
			if( element === dataset.productCode && currentdate > startDate && currentdate < endtDate){
				onlineMessage = true
			}
		});
    }

	function handleClick() {
		window.dispatchEvent(new Event('openMyStore'));
	}

		function infoHandler() {
			infoModal = true
		}

		function closeInfoModal() {
			infoModal = false
		}

		document.querySelector('hh-modal')?.addEventListener('mouseup', (e)=> {
			const container = document.querySelector('hh-modal > div');
			if(container && !container.contains(e.target)){
				infoModal = false;
			}
		})

	
	
	// fire the main function
	!thinking && main()
	
	$: if(availability) {
		onlineOnlymsg();
	}


	// Listen for the event.
	window.addEventListener('storechanged', function() {
		!thinking && main()
	}, false)
	

	// scroll handler
	// let bodyScrollY, stickToTop = false
	// $: if (availability && availability.buyable) {
	// 	bodyScrollY && container && (stickToTop = bodyScrollY > container.parentNode.offsetTop)
	// 	// bodyScrollY && container && (stickToTop = bodyScrollY > container.parentNode.offsetTop+(container.clientHeight/2))
	// 	if (stickToTop) {
	// 		container.classList.add('BuyabilitySticky')
	// 	} else {
	// 		container.classList.remove('BuyabilitySticky')
	// 	}
	// }



</script>
<!-- <svelte:window bind:scrollY={bodyScrollY} /> -->

	{#if thinking}
		<h2 class="Skeleton" style="margin-top:.2em">▇▇▇<small>&nbsp;▇</small></h2>
		<section class="buyability Skeleton">
			<h3>▇ ▇▇▇▇ ▇▇</h3>
			<p>▇ ▇▇▇▇▇ ▇▇ ▇▇▇▇▇ ▇▇▇▇ ▇▇ ▇▇▇▇ ▇▇</p>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
		</section>
		<br />
		<br />
		<br />
	{/if}

	{#if availability}
		{#if 
			availability?.codes?.includes('DO_NOT_DISPLAY_NEW') &&
			(availability?.inventory?.store ?? 0) <= 0 && availability?.inventory?.warehouse <= 0 && (availability?.inventory?.sth <= 0 || !availability?.debug?.isSTH || !availability?.debug?.storeSTH)
		}
			<ProductFlags displayPrice={false} dynAttr21={false} dynAttr295={dynAttr295} isComingSoon={true}/>
			<section class="buyability">
				<h3>{@html lang=='en'
						? "This item isn't available online yet. Contact your store for availability."
						: "	Cet article n'est pas encore disponible en ligne. Communiquez avec votre magasin pour connaître les disponibilités."
					}
				</h3>
				<p>
					<!-- svelte-ignore a11y-invalid-attribute -->
					<a href="" on:click|preventDefault={() => openProductLocator(productCode, productName, productBrand)}>{preferredStoreAddress.name}</a>
					<CartControl {...cartControlProps} buyability={false}/>
				</p>
				<div class="contactStore">
					<img src="https://homehardware.sirv.com/hh/icons/icon-home.store.svg" alt="Home Icon" width="22" height="22">
					<p>
						{#if preferredStoreAddress?.address.address1 && preferredStoreAddress?.address.address1 != 'N/A'}
							{preferredStoreAddress.address.address1}<br>
						{:else if preferredStoreAddress?.address.address2 && preferredStoreAddress?.address.address2 != 'N/A'}
							{preferredStoreAddress.address.address2}<br>
						{/if}
						{preferredStoreAddress.address.cityOrTown}, {preferredStoreAddress.address.stateOrProvince} {preferredStoreAddress.address.postalOrZipCode.slice(0,3)} {preferredStoreAddress.address.postalOrZipCode.slice(3,6)}
					</p>
					{#if preferredStoreAddress?.phone}
						<img src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="Tel Icon" width="22" height="22">
						<p>{preferredStoreAddress.phone}</p>
					{/if}
					{#if preferredStoreAddress?.shippingOriginContact?.email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)}
						<img src="https://homehardware.sirv.com/hh/icons/icon-email-black.svg" alt="Email Icon" width="22" height="22">
						<p>{preferredStoreAddress.shippingOriginContact.email}</p>
						{/if}
					</div>
			</section>
		{:else if
			(availability?.codes?.includes('DISCONTINUED') && availability?.debug?.isSupplierDirectItem && (availability?.inventory?.store ?? 0) <= 0) ||
			(availability?.codes?.includes('DISCONTINUED') && !availability?.debug?.isSupplierDirectItem && (availability?.inventory?.store ?? 0) <= 0 && availability?.inventory?.warehouse <= 0 && (availability?.inventory?.sth <= 0 || !availability?.debug?.isSTH || !availability?.debug?.storeSTH))
		}
			<section class="buyability">
				<h3>{lang == 'en' ? 'Item discontinued' : 'Article abandonné'}</h3>
			</section>
		{:else if availability?.codes?.includes('DISCONTINUED_FOR_SEASON') && !availability?.debug?.isSupplierDirectItem && (availability?.inventory?.store ?? 0) <= 0 && availability?.inventory?.warehouse <= 0 && (availability?.inventory?.sth <= 0 || !availability?.debug?.isSTH || !availability?.debug?.storeSTH)}
			<section class="buyability">
				<h3>{lang == 'en' ? 'Item discontinued for the season' : 'Article abandonné pour la saison'}</h3>
				<CartControl {...cartControlProps}/>
			</section>
		{:else}
			{#if availability?.codes?.includes('RETAIL_ITEM') || availability?.price?.price !== 999999}
				{#if availability?.codes?.includes('FULL_ASSORTMENT')}
					<!-- Don't Show Price -->
					<ProductFlags displayPrice={false} dynAttr21={dynAttr21}></ProductFlags>
				{:else}
				<Price price={availability.price} uom={dataset.tenantHhSellingUom} dotw={dotw} onlineOnlyProduct={onlineOnlyProduct}  availability ={availability.debug} lang={lang} ehf={availability.ehf} dynAttr21={dynAttr21} dynAttr295={dynAttr295} isBuyable={availability.buyable} pricePerSqFt={dataset.pricePerSqFt}>

				{#if availability.debug?.isOnlineClearence === true || onlineMessage === true || dotw == 'true' || onlineOnlyProduct === true }
					<h4 class="h5 Light"><strong>{_strings.onlineOnly}</strong> {_strings.onlineOnlySaving}</h4>
				{/if}
				{#if coupons?.discounts?.length }
					{#each coupons?.discounts as coupon}
						{#if coupon.discountDescription && ((availability.price?.salePrice && coupon?.appliesToSaleProduct) || !availability.price?.salePrice)}
							<div class="coupons-section">
								<img class="coupon-img" src="https://homehardware.sirv.com/hh/icons/coupon-icon.svg" alt="" width="15" height="15">
								<span class="coupons-text">{ coupon.discountDescription }</span>
							</div>
						{/if}
					{/each}
				{/if}
				</Price>
				{/if}
			{:else}
				<ProductFlags displayPrice={false} dynAttr21={dynAttr21}></ProductFlags>
			{/if}

			{#if availability?.codes?.includes('ONLY_BUILDING_CENTRE')}
				<section class="buyability" data-scenario="ONLY_BUILDING_CENTRE">
					<h3>
						{#if lang=='en'}
							Only available at <span>Building Centre Locations <img on:click={infoHandler} src='https://homehardware.sirv.com/hh/icons/icon-info.svg' alt='Info' width='12' heigt='12'/></span>
						{:else}
							Offert seulement dans les <span>Centres de rénovation <img on:click={infoHandler} src='https://homehardware.sirv.com/hh/icons/icon-info.svg' alt='Info' width='12' heigt='12'/></span>
						{/if}
					</h3>
					<p>
						<a href="/product-locator" on:click|preventDefault={()=>openProductLocator(productCode, productName, productBrand)}>{_strings.checkStoreAvailability}</a>
					</p>
					<CartControl {...cartControlProps}/>
				</section>
			{/if}

			{#if availability?.codes?.includes('TEMPORARY_OUT_OF_STOCK')}
				{#if !availability?.debug?.isEcommerceItem && availability?.inventory?.warehouse}
					<section class="buyability" >
						<h3>{_strings.contactLocalStore}</h3>
						<p>
							<a on:click={handleClick}>{preferredStoreAddress.name}</a>
							<CartControl {...cartControlProps}/>
						</p>	
						<section class="contact-local">
							<p>
								<img class="contact-local-info" src="https://homehardware.sirv.com/hh/icons/icon-home.store.svg" height="22" alt="" loading="lazy">
								{#if preferredStoreAddress?.address?.address1 && preferredStoreAddress?.address?.address1 != 'N/A'}
									{preferredStoreAddress.address.address1}<br>
								{:else if preferredStoreAddress?.address?.address2 && preferredStoreAddress?.address?.address2 != 'N/A'}
									{preferredStoreAddress.address.address2}<br>
								{/if}
								{preferredStoreAddress.address.cityOrTown}, {preferredStoreAddress?.address?.stateOrProvince} {preferredStoreAddress?.address?.postalOrZipCode.slice(0,3)} {preferredStoreAddress?.address?.postalOrZipCode.slice(3)}
							</p>
							{#if preferredStoreAddress?.phone}
								<p>
									<img class="contact-local-info" src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" height="22" alt="" loading="lazy">
									{preferredStoreAddress.phone}
								</p>
							{/if}
							{#if preferredStoreAddress?.shippingOriginContact?.email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)}
								<p>
									<img class="contact-local-info" src="https://homehardware.sirv.com/hh/icons/icon-email-black.svg" alt="Email Icon" width="22" height="22">
									{preferredStoreAddress.shippingOriginContact.email}
								</p>
							{/if}
						</section>
					</section>

					<!-- <hh-recs class="similar-items-container" pageType="product" productCode={productCode} component="moreLikeThis" title={lang == 'en' ? `Similar in-stock items`: `Articles similaires en stock`}></hh-recs> -->
					<button class="Button ButtonSecondary" on:click={scrollToSimilarItems}>{lang == 'en' ? `Similar in-stock items`: `Articles similaires en stock`}</button>
					
					
				{:else}
					<!-- NRTI OUT OF STOCK UI -->
					<section class="buyability" >
						<h3>{_strings.outOfStock}</h3>
						<p>
							<a href="/product-locator" on:click|preventDefault = {()=>openProductLocator(productCode, productName, productBrand)}>{_strings.checkStoreAvailability}</a>
							<CartControl {...cartControlProps}/>
						</p>
					</section>

					<!-- <hh-recs class="similar-items-container" pageType="product" productCode={productCode} component="moreLikeThis" title={lang == 'en' ? `Similar in-stock items`: `Articles similaires en stock`}></hh-recs> -->
					<button class="Button ButtonSecondary" on:click={scrollToSimilarItems}>Similar In-Stock Items</button>

					<!-- <section class="similar-items-container" on:availability|preventDefault={window.certonaRecommendations()} datatitle="Similar in-stock items" crtscheme="product2_rr" pagetype="product" productcode="{productCode}"
						data-query-related="{availability.properties.tenantMktKeywords}"
						><noscript>Javascript is required to view Similar in-stock items</noscript></section> -->
				{/if}
			{:else if availability?.codes?.includes('SUPPLIER_DIRECT') && !availability.buyable}
				<!-- SUPPLIER DIRECT UI -->
				{#if availability?.codes?.includes('DISPLAY_SP_INVENTORY') && availability?.codes?.includes('NRTI') }
					<p data-scenario="SUPPLIER_DIRECT">{availability?.codes?.includes('SPECIAL_ORDER') && availability?.codes?.includes('RETAIL_ITEM') && availability?.inventory?.store >= 0 ? _strings.specialOrderText : ''}</p>
				{:else}
					<p data-scenario="SUPPLIER_DIRECT">{availability?.codes?.includes('SPECIAL_ORDER') && availability?.codes?.includes('RETAIL_ITEM') ? _strings.specialOrderText : ''}</p>
				{/if}
				{#if availability?.codes?.includes('DISCONTINUED') && !availability?.inventory?.store > 0 && !availability?.inventory?.warehouse > 0 && !availability?.inventory?.sth > 0}
					<section class="buyability">
						<h3>{lang == 'en' ? 'Item discontinued' : 'Article abandonné'}</h3>
					</section>
				{:else}
					<section class="buyability">
						{#if availability?.codes?.includes('DISPLAY_SP_INVENTORY') && availability?.codes?.includes('NRTI') }
							<h3>
								{#if availability?.codes?.includes('SPECIAL_ORDER') && availability?.codes?.includes('RETAIL_ITEM') && availability?.inventory?.store >= 0 }
									<!-- Empty Block -->
								{:else if availability?.codes?.includes('RETAIL_ITEM') && availability?.inventory?.store > 0}
									{_strings.availableInStore}
								{:else if availability?.codes?.includes('RETAIL_ITEM') && availability?.inventory?.store < 1}
									{_strings.contactStore}
								{:else if availability?.inventory?.store > 0}
									{_strings.contactStore3}
								{:else}
									{_strings.contactStore2}
								{/if}
							</h3>
							<p>
								{#if availability?.inventory?.store > 0}
									<p class="inventory-messaging">
										<span data-stock-count="{ availability?.inventory?.store >= 0 ? availability?.inventory?.store : 0}">
											{ (availability?.inventory?.store <= 500) ? availability?.inventory?.store >= 0 ? availability?.inventory?.store : 0 : '500+' } {_strings.availableAt}
										</span>
										{_strings.at}
										<strong>{preferredStoreAddress.name}</strong>
									</p>
								{/if}
								<a class:product-locator-link={availability?.inventory?.store > 0} href="/product-locator"  on:click|preventDefault = {()=>openProductLocator(productCode, productName, productBrand)}>{availability?.inventory?.store > 0  ? _strings.checkStoreAvailability : preferredStoreAddress.name}</a>
							</p>
						{:else}
							<h3>
								{#if availability?.codes?.includes('SPECIAL_ORDER') && availability?.codes?.includes('RETAIL_ITEM')}
									<!-- No Content -->
								{:else if availability?.codes?.includes('RETAIL_ITEM')}
									{_strings.contactStore}
								{:else}
									{_strings.contactStore2}
								{/if}
							</h3>
							<!-- <strong><span>{preferredStoreAddress.name}</span></strong> -->
							<p>
								<a href="/product-locator" on:click|preventDefault = {()=>openProductLocator(productCode, productName, productBrand)}>{preferredStoreAddress.name}</a>
							</p>
						{/if}
						<div class="contactStore">
							<img src="https://homehardware.sirv.com/hh/icons/icon-home.store.svg" alt="Home Icon" width="22" height="22">
							<p>
								{#if preferredStoreAddress?.address.address1 && preferredStoreAddress?.address.address1 != 'N/A'}
									{preferredStoreAddress.address.address1}<br>
								{:else if preferredStoreAddress?.address.address2 && preferredStoreAddress?.address.address2 != 'N/A'}
									{preferredStoreAddress.address.address2}<br>
								{/if}
								{preferredStoreAddress.address.cityOrTown}, {preferredStoreAddress.address.stateOrProvince} {preferredStoreAddress.address.postalOrZipCode.slice(0,3)} {preferredStoreAddress.address.postalOrZipCode.slice(3,6)}
							</p>
							{#if preferredStoreAddress?.phone}
								<img src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="Tel Icon" width="22" height="22">
								<p>{preferredStoreAddress.phone}</p>
							{/if}
							{#if preferredStoreAddress?.shippingOriginContact?.email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)}
								<img src="https://homehardware.sirv.com/hh/icons/icon-email-black.svg" alt="Email Icon" width="22" height="22">
								<p>{preferredStoreAddress.shippingOriginContact.email}</p>
							{/if}
						</div>
						<CartControl {...cartControlProps}/>
					</section>
				{/if}
			{:else if availability?.codes?.includes('FULL_ASSORTMENT') && availability?.codes?.includes('CONTACT_STORE') && !availability?.inventory?.store > 0}
				<section data-scenario="FULL_ASSORTMENT" class="buyability">
					<p class="h3">{lang == 'en' ? 'Not available online for your store' : 'Non disponible en ligne pour votre magasin'}</p>
					<h4>{lang == 'en' ? 'Contact your store for recommendations' : 'Contactez votre magasin pour obtenir des recommandations'}</h4>
					<div class="contactStore">
						<img src="https://homehardware.sirv.com/hh/icons/icon-home.store.svg" alt="Home Icon" width="22" height="22">
						<p>
							{#if preferredStoreAddress?.name}
								{preferredStoreAddress.name}<br>
							{/if}
							{#if preferredStoreAddress?.address.address1 && preferredStoreAddress?.address.address1 != 'N/A'}
								{preferredStoreAddress.address.address1}<br>
							{:else if preferredStoreAddress?.address.address2 && preferredStoreAddress?.address.address2 != 'N/A'}
								{preferredStoreAddress.address.address2}<br>
							{/if}
							{preferredStoreAddress.address.cityOrTown}, {preferredStoreAddress.address.stateOrProvince} {preferredStoreAddress.address.postalOrZipCode.slice(0,3)} {preferredStoreAddress.address.postalOrZipCode.slice(3,6)}
							{#if preferredStoreAddress?.phone}
								<br>{preferredStoreAddress.phone}
							{/if}
							{#if preferredStoreAddress?.shippingOriginContact?.email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)}
								<br>{preferredStoreAddress.shippingOriginContact.email}
							{/if}
						</p>
					</div>
					<a href="/product-locator" on:click|preventDefault = {()=>openProductLocator(productCode, productName, productBrand)}>{lang == 'en' ? "Check availability at other stores" : "Vérifiez la disponibilité dans d’autres magasins"}</a>
					<CartControl {...cartControlProps}/>	
				</section>			
			{:else if availability?.codes?.includes('CONTACT_STORE')}
				<section class="buyability">
					<h3>{ availability?.codes?.includes('RETAIL_ITEM')? _strings.contactStore: _strings.contactStore2 }</h3>
					<p>
						<!-- <strong><span>{preferredStoreAddress.name}</span></strong> -->
						<a href="/product-locator" on:click|preventDefault = {()=>openProductLocator(productCode, productName, productBrand)}>{preferredStoreAddress.name}</a>
					</p>
					<div class="contactStore">
						<img src="https://homehardware.sirv.com/hh/icons/icon-home.store.svg" alt="Home Icon" width="22" height="22">
						<p>
							{#if preferredStoreAddress?.address.address1 && preferredStoreAddress?.address.address1 != 'N/A'}
								{preferredStoreAddress.address.address1}<br>
							{:else if preferredStoreAddress?.address.address2 && preferredStoreAddress?.address.address2 != 'N/A'}
								{preferredStoreAddress.address.address2}<br>
							{/if}
							{preferredStoreAddress.address.cityOrTown}, {preferredStoreAddress.address.stateOrProvince} {preferredStoreAddress.address.postalOrZipCode.slice(0,3)} {preferredStoreAddress.address.postalOrZipCode.slice(3,6)}
						</p>
						{#if preferredStoreAddress?.phone}
							<img src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="Tel Icon" width="22" height="22">
							<p>{preferredStoreAddress.phone}</p>
						{/if}
						{#if preferredStoreAddress?.shippingOriginContact?.email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)}
							<img src="https://homehardware.sirv.com/hh/icons/icon-email-black.svg" alt="Email Icon" width="22" height="22">
							<p>{preferredStoreAddress.shippingOriginContact.email}</p>
						{/if}
					</div>
					<CartControl {...cartControlProps}/>
				</section>
				<!-- <hh-recs class="similar-items-container" pageType="product" productCode={productCode} component="moreLikeThis" title={lang == 'en' ? `Similar in-stock items`: `Articles similaires en stock`}></hh-recs> -->
				<button class="Button ButtonSecondary" on:click={scrollToSimilarItems}>Similar In-Stock Items</button>

				<!-- <section class="similar-items-container" on:availability|preventDefault={window.certonaRecommendations()} datatitle="Similar in-stock items" crtscheme="product2_rr" pagetype="product" productcode="{productCode}"
				data-query-related="{availability.properties.tenantMktKeywords}"
				><noscript>Javascript is required to view Similar in-stock items</noscript></section> -->
			{:else if availability?.codes?.includes('AVAILABLE_IN_STORE_ONLY')}
				<!-- NRTI AVAILABlE In Store UI -->
				<section class="buyability">
					{#if availability?.codes?.includes('FULL_ASSORTMENT')}
						<h3>{_strings.availableInStoreWithPrice}</h3>
					{:else}
						<h3>{_strings.availableInStore}</h3>
					{/if}
					<p>
						<span data-stock-count="{ availability?.inventory?.store >= 0 ? availability?.inventory?.store : 0}">
							{ (availability?.inventory?.store <= 500) ? availability?.inventory?.store >= 0 ? availability?.inventory?.store : 0 : '500+' } {_strings.availableAt}
						</span>
						{_strings.at}
						<strong>{preferredStoreAddress.name}</strong>
						<a class='product-locator-link' href="/product-locator" on:click|preventDefault = {()=>openProductLocator(productCode, productName, productBrand)}>{_strings.checkStoreAvailability}</a>
					</p>
					<div class="contactStore">
						<img src="https://homehardware.sirv.com/hh/icons/icon-home.store.svg" alt="Home Icon" width="22" height="22">
						<p>
							{#if preferredStoreAddress?.address.address1 && preferredStoreAddress?.address.address1 != 'N/A'}
								{preferredStoreAddress.address.address1}<br>
							{:else if preferredStoreAddress?.address.address2 && preferredStoreAddress?.address.address2 != 'N/A'}
								{preferredStoreAddress.address.address2}<br>
							{/if}
							{preferredStoreAddress.address.cityOrTown}, {preferredStoreAddress.address.stateOrProvince} {preferredStoreAddress.address.postalOrZipCode.slice(0,3)} {preferredStoreAddress.address.postalOrZipCode.slice(3,6)}
						</p>
						{#if preferredStoreAddress?.phone}
							<img src="https://homehardware.sirv.com/hh/icons/icon-tel.black.svg" alt="Tel Icon" width="22" height="22">
							<p>{preferredStoreAddress.phone}</p>
						{/if}
						{#if preferredStoreAddress?.shippingOriginContact?.email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)}
							<img src="https://homehardware.sirv.com/hh/icons/icon-email-black.svg" alt="Email Icon" width="22" height="22">
							<p>{preferredStoreAddress.shippingOriginContact.email}</p>
						{/if}
						<img src="https://homehardware.sirv.com/hh/icons/icon-location.black.svg" alt="Location Icon" width="22" height="22">
						<a class="getDirection" href="https://www.google.com/maps/dir//{preferredStoreAddress.geo.lat},{preferredStoreAddress.geo.lng}" target="_blank">Get Directions</a>
					</div>
					<CartControl {...cartControlProps}/>
				</section>
			{/if}

			{#if availability.buyable}
				{#if availability?.codes?.includes('IN_STOCK_ONLINE') || availability?.codes?.includes('SHIP_TO_HOME_ONLY') || availability?.codes?.includes('BOPIS_ONLY') }
					<!-- Based On NRTI/NON-NRTI We will create the 2 different UI's -->
					<section class="buyability" data-scenario="FULFILLMENT_AVAILABLE">
						<Shipping price={availability.price} productCode={productCode} lang={lang} dataset={dataset} availabilityData={availability} buyabilityDataLayer={buyabilityDataLayer}/>	
					</section>
					{#if coveragePrice}
						<SqFtCalculator 
							coveragePrice={coveragePrice} 
							availability={availability} 
							lang={lang} 
							dataset={dataset} 
							formatMoney={formatMoney} 
						/>
					{/if}
					<CartControl {...cartControlProps}/>
					<!-- {#if availability.debug?.isOnlineClearence === true || onlineMessage === true || dotw == 'true'}
						<h4 class="h4 Light"><strong>{_strings.onlineOnly}</strong> {_strings.onlineOnlySaving}</h4>
					{/if} -->
				{/if}
				<!-- <CartControl buyability={true}/>
				{#if availability.debug?.isOnlineClearence === true || onlineMessage === true}
					<h4 class="h4 Light"><strong>Online Only Savings.</strong> While supplies last.</h4>
				{/if}
				<Shipping productCode={productCode} lang={lang} dataset={dataset}/>	 -->
			{/if}
		{/if}


		<!-- {#if availability?.codes?.includes('OUT_OF_STOCK_AT_STORE')}
			<p style="font-weight: bold; color: orange">Out of stock at your store</p>
		{:else if availability?.codes?.includes('IN_STOCK_AT_STORE')}
			<p style="font-weight: bold; color: green">{parseInt(availability.inventory?.store||0)} in stock at your store</p>
		{:else}
			<p style="font-weight: bold; color: grey">not available at your store</p>
		{/if}

		{#if availability?.codes?.includes('OUT_OF_STOCK_ONLINE')}
			<p style="font-weight: bold; color: orange">Out of stock online</p>
		{:else if availability?.codes?.includes('IN_STOCK_ONLINE')}
			<p style="font-weight: bold; color: green">{parseInt(availability.inventory?.warehouse||0) + parseInt(availability.inventory?.sth||0) + parseInt(availability.inventory?.banana||0)} in stock online</p>
		{:else}
			<p style="font-weight: bold; color: grey">not available online</p>
		{/if} -->


		<!-- {#if availability.buyable}
			<CartControl buyable={availability.buyable} />
			{#if availability.debug?.isOnlineClearence === true}
				<h4 class="h4 Light"><strong>Online Only Savings.</strong> While supplies last.</h4>
			{/if}
			<Shipping productCode={productCode} lang={lang} dataset={dataset}/>	
		{/if} -->
			
		
	{:else}
		{#if errorCode === 'NOT_IN_PRICELIST'}
			<!-- Make NOT_IN_PRICELIST UI -->
			<ProductFlags displayPrice={false} dynAttr295={dynAttr295}></ProductFlags>

			<section class="buyability" data-scenario="NOT_IN_PRICELIST">
				<h3>{_strings.notInPricelist}</h3>
				<p>
					<a href="/product-locator" on:click|preventDefault={()=>openProductLocator(productCode, productName, productBrand)}>{_strings.checkStoreAvailability}</a>
				</p>
				<CartControl {...cartControlProps}/>
			</section>
		{/if}
		<!-- checking availability ({lang}) -->
	{/if}

	{#if infoModal}
		<Portal target='hh-modal'>
			<img src="https://homehardware.sirv.com/hh/svg/icon.close-black.svg" class="modal-closeBtn" alt="no img" width="15" height="15" style="display:flex; justify-content: flex-end;" on:click={closeInfoModal} loading="lazy">
			<div class="modal-header"><img class="Center" src="https://homehardware.sirv.com/hh/icons/icon-hard-hat.svg" alt="Hard Hat" width="100%" height="26" loading="lazy"></div>
			<p class="modal-content">
				{@html _strings.buildingCentreInfoModal}
			</p>
		</Portal>
	{/if}
	
	<!-- <details>+
		<summary>Diagnostics</summary>
		<pre>{JSON.stringify(availability, null, 2)}</pre>
	</details>

	<details>
		<summary>Svelte Store</summary>
		<pre>{JSON.stringify({ quantity: $quantity, postal: $postal, shipping: $shipping, method: $method }, null, 2)}</pre>
	</details> -->


<style>
	hh-pricing,
	hh-stock,
	#hh-add-to-cart {
		display: block
	}
	:global(#hh-mfe-pdp-buy){
		margin-bottom: 2rem;
	}

	.similar-items-container {
		max-width: 540px;
	}
	.coupons-section {
		display: flex;
		gap: 6px;
		margin-top: 28px;
	}
	.coupons-text {
		font-family: 'hhAgendaBold';
		font-size: 1rem;
		line-height: 21px;
		/* letter-spacing: 0.0077em; */
	}
	.coupon-img {
		margin-top: 5px;
	}
	.buyability {
		position: relative;
		background-color: #f7f7f7;
		padding: 1.5rem 2rem 0;
		border-radius: 5px;
		margin-bottom: 1.25rem;
		margin-top: 1.25rem;
	}
	.buyability:not([data-scenario="FULFILLMENT_AVAILABLE"]){
		padding-bottom: 1.5rem;
	}
	.buyability[data-scenario="ONLY_BUILDING_CENTRE"] {
		display: grid;
		grid-template-columns: 6fr 2fr;
	}
	.buyability[data-scenario="ONLY_BUILDING_CENTRE"] > *:nth-child(2) {
		grid-row: 2/3;
		grid-column: 1/3;
	}
	:global(.buyability[data-scenario="ONLY_BUILDING_CENTRE"] > h3 > span:first-child){
		display: inline-block;
	}
	.buyability[data-scenario="ONLY_BUILDING_CENTRE"] > h3 img {
		cursor: pointer;
	}
	.buyability h3 {
		padding-right: calc(var(--gap) * 2);
	}
	.buyability[data-scenario="FULL_ASSORTMENT"] > p:first-child{
		font-family: 'hhAgendaMedium';
		margin-right: 2rem;
	}
	.buyability[data-scenario="FULL_ASSORTMENT"] > a{
		display: inline;
	}
	@media(max-width:600px) {
		.buyability[data-scenario="FULL_ASSORTMENT"] > p:first-child{
			font-size: 1.25rem;
		}
	}
	/* .buyability > h3 + p {
		padding-bottom: 0 !important;
		padding-right: calc(var(--gap) * 2);
	} */
	.buyability:not([data-scenario="FULFILLMENT_AVAILABLE"]) > h3 + p {
		padding-bottom: 0 !important;
		padding-right: calc(var(--gap) * 2);
	}
	@media (max-width: 999px) {
		.buyability h3 {
			padding-right: calc(var(--gap) * 3.25);
		}
		.buyability:not([data-scenario="FULFILLMENT_AVAILABLE"]) > h3 + p {
			padding-right: calc(var(--gap) * 3.25);
		}
	}
	.buyability a {
		font-size: 1.125rem;
		display: inline-block;
		text-decoration: underline;
		text-underline-position: under;
		margin-top: 0.75rem;
		font-family: 'hhAgendaBold';
	}
	.buyability a.product-locator-link {
		display: block;
		font-size: 1rem;
		font-family: 'hhAgendaMedium';
		color: #54585A;
		margin-top: 0;
	}

	.buyability > strong > span {
		font-size: 1.125rem;
		display: inline-block;
		margin-top: 0.75rem;
	}
	p[data-scenario="SUPPLIER_DIRECT"] {
		color:#54585A;
	}
	.inventory-messaging {
		font-size: 1.125rem;
		padding: 0.75rem 0 0;
	}
	.contactStore {
		display: grid;
		grid-template-columns: 0.5fr 10fr;
		grid-column-gap: 10px;
		padding-top: 20px
	}
	.contactStore p{
		padding-top: 0;
		font-size: 1.125rem;
	}
	.buyability > span{
		color: var(--hh-green);
	}
	.getDirection{
		margin-top: 0!important;
		font-family: 'hhAgendaMedium' !important;
	}


	.contact-local {
		display: flex;
		flex-direction: column;
		margin-top: var(--gap);
		gap: calc(var(--gap)/2);
	}
	.contact-local > p {
		display: flex;
		gap: calc(var(--gap)/2);
		margin: 0;
		padding: 0;
	}
	.contact-local-info {
		display: flex;
		gap: calc(var(--gap)/2);
	}

	.getDirection{
		margin-top: 0!important;
		font-family: 'hhAgendaMedium' !important;
	}

	h4 {
		padding-top: .75em;
	}

	.modal-closeBtn {
		position: absolute;
		top: 8px;
		right: 10px;
		cursor: pointer;
	}
	.modal-header {
		margin-bottom: 0.25rem;
		border-bottom: 1px solid var(--hh-grey);
	}
	.modal-content {
		max-width: 345px;
		text-align: center;
		padding: 0.75em 0.9em;
		border-bottom: 1px solid var(--hh-grey);
	}
</style>